import Link from "next/link";
import { IoDownloadOutline } from "react-icons/io5";
import { TypesenseResource } from "../../models/resources";

export const ResourceCard = ({ hit, searchText }: { hit: TypesenseResource; searchText: string; }) => {

    let description = `${hit?.content?.substring(0, 200)}...`;
    let substrings: string[] = [];

    if (searchText?.length >= 3) {
        substrings = hit?.content?.split(searchText);
    }

    return (
        <Link href={'/m/resources/resource-details'} passHref>
            <div className="border cursor-pointer mb-3 p-3 align-items-center col-lg-8 col-md-12 rounded">
                <div className='d-flex align-items-center pb-2 justify-content-between opportunity-card border-bottom'>
                    <p className='mb-0 fw-bold'>
                        {hit?.name}
                    </p>
                    <div className='text-center'>
                        <IoDownloadOutline size={20} />
                        <br />
                        <span style={{ fontSize: 10 }}>Download</span>
                    </div>
                </div>
                {searchText?.length >= 3
                    ? <p className="pt-2">{substrings?.map((item, index) => (
                        <span key={index}>
                            {index != 0 && <span className='bold'>{searchText}</span>}
                            {index === 0 ?
                                `...${item?.substring(item?.length - 50, item?.length)} `
                                : index === substrings?.length - 1
                                    ? ` ${item?.substring(0, 50)}...${item?.substring(item?.length - 50, item?.length)} `
                                    : ` ${item?.substring(0, 50)} `}
                        </span>
                    ))}</p>
                    : <p className="pt-2">{description}</p>}
            </div>
        </Link>
    );
}
